import axios, { AxiosResponse } from "axios";
import { BaladyTokenResponse } from "../models/BaladyTokenResponse";
import { PointDataArrayResponse, PointDataResponse } from "../models/PointDataResponse";

const baseUrl = "https://thki.sa/api/api/";
const baladyBaseUrl = "https://apiservices.balady.gov.sa/";


//nafaz
export const loginCallBackNafazFunction = async (id: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/LoginCallBackNafaz?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};
export const CallBackNafazFunction = async () => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/CallBackNafaz`,
    {
      response: "dsdsdsd"
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};



export const getAPPViewsFunction = async (token: string) => {
  if (token) {
    return await axios.get(
    `${baseUrl}LandDesign/GetAPPViews`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
}
};


export const onFileUploadValidationSize = async (file: any, size: number) => {
  if (file) {
    if (file.size <= size)
      return true;
  }
  return false;
};


export const getPropertyAdvertisementsFunction = async (parcel_Cod: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetAddLandDetailsTypes?objId=${parcel_Cod}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};


export const getNhcIntegrationByObjIdFunction = async (objId: any) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/GetNhcIntegrationByObjId?objId=${objId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

/** Ad object ids with their property type, for the home map's filters dropdown. */
export const getAdsForMapFilterFunction = async () => {
  return await axios.get(`${baseUrl}NhcIntegration/GetAdsForMapFilter`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const getFavoriteLandByParcCodeFunction = async (parcel_Cod: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/getFavoriteLandByParcCode?parcel_Cod=${parcel_Cod}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const getMyAdvertisementsFunction = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetAddLandDetailsByUserId?subUserId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const deleteNhcIntegration = async (id: any, token: any) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/DeleteNhcIntegration?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const getAllNhcIntegrationFunction = async (token: any) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/GetAllNhcIntegration`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const getNhcIntegrationByUserIdFunction = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/GetNhcIntegrationByUserId?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const deleteAccountFunction = async (token: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/DeleteUser`,
    {
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const getPropertyTypes = async (token: string) => {
  return await axios({
    method: "get",
    url: `${baseUrl}LandDesign/GetAddLandTypes`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const addAdvertisementFunction = async (formData: any, token: String) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}LandDesign/CreateLandDetails`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};


export const CheckNhcIntegration = async (formData: any, token: String) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}NhcIntegration/CheckNhcIntegration`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const GetTypeOfProperty = async (token: String, propertyType: string, advertisementType: string, AdLicenseNumber?: number) => {
  if (propertyType && advertisementType) {
    return await axios({
      method: "get",
      url: `${baseUrl}NhcIntegration/type-of-property`,
      params: {
        propertyType,
        advertisementType,
        AdLicenseNumber
    },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const CreateNhcIntegration = async (formData: any, token: String) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}NhcIntegration/CreateNhcIntegration`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const GetSimilarAds = async (
  token: string,
  adLicenseNumber?: string,
  objectId?: number,
) => {
  if (!token) throw new Error("Token is required.");

  if (!adLicenseNumber && !objectId) {
    throw new Error("Either adLicenseNumber or objectId must be provided.");
  }

  return await axios({
    method: "get",
    url: `${baseUrl}NhcIntegration/GetSimilarAds`,
    params: {
      adLicenseNumber: adLicenseNumber || undefined,
      objectId: objectId || undefined,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  });
};

export const RestoreAdState = async (token: String, AdLicenseNumber: String) => {
  if (AdLicenseNumber && token) {
    return await axios({
      method: "post",
      url: `${baseUrl}Brokerage/RestoreAdState`,
      params: {
        AdLicenseNumber,
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const getAdvertisementFilesFunction = async (file: any, Parcel_Cod: any, token: any) => {
  return await axios.post(
    `${baseUrl}Files/DowmloadFilesBase64`,
    {
      fileName: file.name,
      fileType: file.type,
      Parcel_Cod: Parcel_Cod
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const dowmloadFilesBuildingsWalletBase64Function = async (fileName: any, fileTypeId: any, token: any) => {
  return await axios.get(
    `${baseUrl}Files/dowmloadFilesBuildingsWalletBase64?fileName=${fileName}&fileTypeId=${fileTypeId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const deleteAdvertisementOfPropertyFunction = async (
  advertisementId: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}LandDesign/DeleteLandDetailsForMobile`,
    {
      ad_Id: advertisementId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const saveFilesDataFunction = async (
  fileBase64: any,
  parcel_Cod: String,
  fileName: String,
  token: string
) => {
  return await axios.post(
    `${baseUrl}Files/SaveFilesData`,
    {
      fileBase64: fileBase64,
      parcel_Cod: parcel_Cod,
      fileName: fileName,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const UpdateAdDateLandDetailsAsyncFunction = async (
  advertisementId: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}LandDesign/UpdateAdDateLandDetailsAsync`,
    {
      ad_Id: advertisementId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const editAdvertisementOfPropertyFunction = async (
  formData: any,
  token: String
) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}LandDesign/UpdateLandDetailsAsync`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const getAdvertisementByPropertyFunction = async (
  parcel_Cod: any,
  ad_Id: any
) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetAddLandDetails?Parcel_Cod=${parcel_Cod}&ad_Id=${ad_Id}`,

    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};


export const getNhcIntegrationByAdLicenseNumberFunction = async (
  adLicenseNumber: any,
  addIDType: any,
  addId?: any, // Optional parameter for specific advertisement ID
) => {
  let url = `${baseUrl}NhcIntegration/GetNhcIntegrationByAdLicenseNumber?adLicenseNumber=${adLicenseNumber}&addIDType=${addIDType}`;
  
  // Add addId parameter if provided
  if (addId) {
    url += `&addId=${addId}`;
  }
  
  return await axios.get(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const GetAddLandDetailsWaittingApprovalFunction = async (token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetAddLandDetailsWaittingApproval`,

    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const getFullNameFunction = async (
  id: any
) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetFullName?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

//logo functions
export const createLogosDataFunction = async (model: any, token: any) => {
  return await axios.post(
    `${baseUrl}LandDesign/CreateLogosData`,
    model,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const editLogosDataIsActiveFunction = async (model: any, token: any) => {
  return await axios.post(
    `${baseUrl}LandDesign/EditLogosDataIsActive`,
    model,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const ApprovalAddsFunction = async (addID: any, isApproval: any, rejectNotes: any, token: any) => {
  return await axios.post(
    `${baseUrl}LandDesign/ApprovalAdds`,
    {
      addID: addID,
      isApproval: isApproval,
      rejectNotes: rejectNotes
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const getLogosDataFunction = async () => {
  return await axios.get(
    `${baseUrl}LandDesign/GetLogosData`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const getLogoslogoAddFunction = async (token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetLogoslogoAdd`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const deleteLogosDataFunction = async (logoID: any, token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/DeleteLogosData?logoID=${logoID}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const uploadFileToAdvertisementFunction = async (file: any, token: any) => {
  const uploadForm = new FormData();
  uploadForm.append("file", file);
  return await axios.post(
    `${baseUrl}Files/UploadFiles?fileName=${file.name}`,
    uploadForm,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const addFileToAdvertisementFunction = async (formData: any, token: any) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}Files/CreateFilesDetails`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};


export const AddPhoneAndMailFunction = async (PhoneNumber: any, UserId: any, Email: any, oTPCode: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/AddPhoneAndMail`,
    {
      PhoneNumber: PhoneNumber,
      UserId: UserId,
      Email: Email,
      oTPCode: oTPCode,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const GetPhoneAndMailFunction = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/GetPhoneAndMail?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const createFavoriteLandFunction = async (
  Parcel_Cod: number,
  UserId: any,
  token: any,
  District_Name: any,
  City_Name: any,
  Neighbourhood_Name: any,
  Land_Numbe: any,
  Latitude: any,
  Longitude: any,
  FavoriteLandObjId: any
) => {
  return await axios.post(
    `${baseUrl}LandDesign/CreateFavoriteLand`,
    {
      parcel_Cod: Parcel_Cod,
      userId: UserId,
      District_Name: District_Name,
      City_Name: City_Name,
      Neighbourhood_Name: Neighbourhood_Name,
      Land_Numbe: Land_Numbe,
      Latitude: Latitude,
      Longitude: Longitude,
      FavoriteLandObjId: FavoriteLandObjId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const getFavoriteLandFunction = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetFavoriteLand?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const getFavoriteLandAllFunction = async (token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/GetFavoriteLandAll`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const deleteFavoriteLandFunction = async (id: number, token: any) => {
  return await axios.get(
    `${baseUrl}LandDesign/DeleteFavoriteLand?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const deleteAllFilesOfAdvertisementFunction = async (
  advertisementId: any,
  Parcel_Cod: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}Files/DeleteFilesDetails`,
    {
      ad_Id: advertisementId,
      Parcel_Cod: Parcel_Cod,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const deleteFilesByIDOfAdvertisementFunction = async (
  fileId: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}Files/DeleteFilesDetailsByID`,
    {
      FileID: fileId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

};

export const getArcGISTokenFunction = async () => {
  let url = `https://www.arcgis.com/sharing/generateToken?f=json&referer=https://www.arcgis.com`;
  const params = new URLSearchParams()
  params.append("username", "thkiSa")
  params.append("password", "Thki.sa2587**")

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }

  return axios.post(url, params, config)
};


//IdentitySecurity
export const signInFunction = async (values: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/Login`,
    {
      UserName: values.userName,
      Password: values.password,
      OTPCode: values.OTPCode
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const loginNafazFunction = async (personIdValue: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/loginNafaz`,
    {
      personId: personIdValue,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};



export const getAPPVersionsFunction = async () => {
  return await axios.get(
    `${baseUrl}LandDesign/GetAPPVersions`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const SendOTPToPhoneNumber = async (phoneNumber: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/SendOTPToPhoneNumber?phone=${phoneNumber}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const ValidateOTPPhoneNumber = async (phone: any, code: any, userId: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/ValidatePhoneNumber?phone=${phone}&code=${code}&userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const ForgotPasswordFunc = async (model: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/ForgotPassword`,
    {
      "phoneNumber": model.phoneNumber,
      "userId": model.userId,
      "newPassword": model.newPassword,
      "oTPCode": model.oTPCode
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const signUpFunction = async (values: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/RegisterUser`,
    {
      fullName: values.fullName,
      email: values.email,
      phoneNumber: values.phoneNumber,
      userName: values.userName,
      password: values.password,
      confirmPassword: values.confirmPassword,
      ad_Number: values.advertiserNumber,
      classOfAccount: 0,
      oTPCode: values.oTPCode,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

/*/////////////////////////////////////////*/
export const EditUserFunction = async (values: any, image: any, token: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/EditUser`,
    {
      id: values.id,
      profileImage: image ?? undefined,
      address: values.address ?? undefined,
      email: values.email ?? undefined,
      phoneNumber: values.phoneNumber ?? undefined,
      officePhoneNumber: values.officePhoneNumber ?? undefined,
      bio: values.bio ?? undefined,
      nickName: values.nickName ?? undefined,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*/////////////////////////////////////////*/

export const EditUsersInRoleFunction = async (userId: any, roles: any, token: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/EditUsersInRole`,
    {
      userId: userId,
      role: roles
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

/*//////////////////////////////////////*/
export const GetUserFunction = async (id: any, token: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/GetUser?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetProfileImageFunction = async (id: any, token: any) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/GetProfileImage?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*//////////////////////////////////////*/

export const GetUserListFunction = async (token: any) => {
  return await axios.get(
    `${baseUrl}IdentitySecurity/GetUserList`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const SendMessagesToGetLogo = async (message: any, UserId: any, IsReport: any, IsLogoMessage: any, token: any) => {
  return await axios.post(
    `${baseUrl}IdentitySecurity/SendMessagesToGetLogo`,
    {
      message: message,
      UserId: UserId,
      IsReport: IsReport,
      IsLogoMessage: IsLogoMessage
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};



//BuildingsWallet
export const CreateBuildingsWalletFunc = async (model: any, token: any) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/CreateBuildingsWallet`,
    {
      "Parcel_Cod": model.Parcel_Cod,
      "City_Name": model.City_Name,
      "District_Name": model.District_Name,
      "Neighbourhood_Name": model.Neighbourhood_Name,
      "Land_Numbe": model.Land_Numbe,
      "Longitude": model.Longitude,
      "Latitude": model.Latitude,

    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetBuildingsWalletByIdFunc = async (parcelId: any, token: any) => {
  // console.log("parcelId", parcelId);

  return await axios.get(
    `${baseUrl}BuildingsWallet/GetBuildingsWalletById?parcelId=${parcelId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetBuildingsWalletFunc = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}BuildingsWallet/GetBuildingsWallet?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetGenerateLinkBuildingsWalletFunc = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}BuildingsWallet/GetGenerateLinkBuildingsWallet?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetPointsEarnedCounterByUserIDFunc = async (userId: any, token: any) => {
  return await axios.get(
    `${baseUrl}BuildingsWallet/GetPointsEarnedCounterByUserID?userId=${userId}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};



export const GenerateLinkBuildingsWalletFunc = async (UserId: any, token: any) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/GenerateLinkBuildingsWallet`,
    {
      UserId: UserId
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const AsynPointsEarnedCounterByUserIDFunc = async (code: any, token: any) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/AsynPointsEarnedCounterByUserID`,
    {
      Code: code
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const CreateBuildingsWalletSingleFunc = async (formData: any, token: any) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}BuildingsWallet/CreateBuildingsWalletSingle`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const EditCreateBuildingsWalletSingleFunc = async (formData: any, token: any) => {
  if (formData) {
    return await axios({
      method: "post",
      url: `${baseUrl}BuildingsWallet/EditCreateBuildingsWalletSingle`,
      data: formData,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, Accept: "application/json" },
    })
  }
};

export const DeleteBuildingsWalletFunc = async (Id: any, token: any) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/DeleteBuildingsWallet`,
    {
      Id: Id
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const DeleteBuildingsWalletSingleFunc = async (Id: any, token: any) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/DeleteBuildingsWalletSingle`,
    {
      Id: Id
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};


export const EditTitleInBuildingsWalletParcelFunction = async (
  Id: any,
  Title: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/EditTitleInBuildingsWalletParcel`,
    {
      Id: Id,
      Title: Title,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const EditTypeInBuildingsWalletFunction = async (
  userId: any,
  TypeInBuildingsWallet: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}BuildingsWallet/EditTypeInBuildingsWallet`,
    {
      userId: userId,
      TypeInBuildingsWallet: TypeInBuildingsWallet,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const deleteFilesByBuildingsWalletParcelFunction = async (
  Id: any,
  UserId: any,
  token: String
) => {
  return await axios.post(
    `${baseUrl}Files/deleteFilesByBuildingsWalletParcel`,
    {
      FileID: Id,
      UserId: UserId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

export const GetMaxAddCountByRegionFunction = async (region: any, getOthsersUser: boolean = false) => {
  return await axios.get(
    `${baseUrl}NhcIntegration/GetMaxAddCountByRegion?region=${region}&getOthsersUser=${getOthsersUser}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};


/*/////////////////////////////////////////*/
export const GetPaymentTypes = async (token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/GetPaymentTypes`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

/*/////////////////////////////////////////*/

export const GetAllPaymentOrders = async (token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/GetAllPaymentOrders`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*/////////////////////////////////////////*/

export const GetPaymentOrdersByUser = async (id: string, token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/GetPaymentOrdersByUser?id=${id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

/*/////////////////////////////////////////*/

export const CreateCharge = async (paymentType: any, token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/CreateCharge?paymentType=${paymentType}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*/////////////////////////////////////////*/

export const PaymentCompleted = async (charge_id: any, token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/PaymentCompleted?charge_id=${charge_id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*/////////////////////////////////////////*/

export const GetPaymentChargersByUser = async (userid: any, token: string) => {
  return await axios.get(
    `${baseUrl}Invoices/GetPaymentChargersByUser?id=${userid}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};
/*/////////////////////////////////////////*/

export const GetBaladyToken = async (): Promise<AxiosResponse<BaladyTokenResponse>> => {
  return await axios.get<BaladyTokenResponse>(
    `${baseUrl}NhcIntegration/GetBaladyToken`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

/*/////////////////////////////////////////*/

export const GetPointData = async (
  token: string,
  x: string,
  y: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = { x, y };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }

  try {
    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/point-data`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying GetPointData with new token");
        
        return await axios.get<PointDataResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/point-data`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry GetPointData with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};

/*/////////////////////////////////////////*/

export const getAllRegionsData = async (
  token: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {

    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    } catch (error: any) {
      // If we get a 401 Unauthorized error, clear the cookies and retry with new token
      if (error.response?.status === 401) {
        console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
        
        // Import and use the clearBaladyToken function
        const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
        clearBaladyToken();
        
        // Get a new token and retry the request
        try {
          const newToken = await getBaladyAccessToken();
          console.log("Retrying getAllRegionsData with new token");
          
          return await axios.get<PointDataResponse>(
            `${baladyBaseUrl}v1/gis-generic-services/regions`,
            {
              params,
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${newToken}`,
              },
            }
          );
        } catch (retryError: any) {
          console.error("Failed to retry getAllRegionsData with new token:", retryError);
          throw retryError;
        }
      }
      
      // Re-throw the error for non-401 errors
      throw error;
    }
};

/*/////////////////////////////////////////*/

export const getRegionDataByCode = async (
  regionCode: string,
  token: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataArrayResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {
    return await axios.get<PointDataArrayResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions/${regionCode}`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying getRegionDataByCode with new token");
        
        return await axios.get<PointDataArrayResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/regions/${regionCode}`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry getRegionDataByCode with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};

/*/////////////////////////////////////////*/

export const getCitiesDataOfRegion = async (
  selectedRegionCode: string,
  token: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {
    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying getCitiesDataOfRegion with new token");
        
        return await axios.get<PointDataResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry getCitiesDataOfRegion with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};

/*/////////////////////////////////////////*/

export const getDistrictsDataOfCity = async (
  selectedRegionCode: string,
  selectedCityCode: string,
  token: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {
    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying getDistrictsDataOfCity with new token");
        
        return await axios.get<PointDataResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry getDistrictsDataOfCity with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};

/*/////////////////////////////////////////*/

export const getPlanDataOfDistrict = async (
  selectedRegionCode: string,
  selectedCityCode: string,
  selectedDistrictCode: string,
  token: string,
  requestNumber?: string
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {
    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts/${selectedDistrictCode}/plans`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying getPlanDataOfDistrict with new token");
        
        return await axios.get<PointDataResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts/${selectedDistrictCode}/plans`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry getPlanDataOfDistrict with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};

/*/////////////////////////////////////////*/

export const getParcelsDataOfPlan = async (
  selectedRegionCode: string,
  selectedCityCode: string,
  selectedDistrictCode: string,
  planNo: string,
  token: string,
  requestNumber?: string,
): Promise<AxiosResponse<PointDataResponse>> => {
  const params: Record<string, string> = {  };

  if (requestNumber) {
    params.requestNumber = requestNumber;
  }
  try {
    return await axios.get<PointDataResponse>(
      `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts/${selectedDistrictCode}/parcels?requestNumber=${requestNumber}&planNo=${planNo}`,
      {
        params,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error: any) {
    // If we get a 401 Unauthorized error, clear the cookies and retry with new token
    if (error.response?.status === 401) {
      console.warn("Balady token expired (401 Unauthorized), clearing cookies and retrying with new token");
      
      // Import and use the clearBaladyToken function
      const { clearBaladyToken, getBaladyAccessToken } = await import("./baladyService");
      clearBaladyToken();
      
      // Get a new token and retry the request
      try {
        const newToken = await getBaladyAccessToken();
        console.log("Retrying getParcelsDataOfPlan with new token");
        
        return await axios.get<PointDataResponse>(
          `${baladyBaseUrl}v1/gis-generic-services/regions/${selectedRegionCode}/cities/${selectedCityCode}/districts/${selectedDistrictCode}/parcels?requestNumber=${requestNumber}&planNo=${planNo}`,
          {
            params,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${newToken}`,
            },
          }
        );
      } catch (retryError: any) {
        console.error("Failed to retry getParcelsDataOfPlan with new token:", retryError);
        throw retryError;
      }
    }
    
    // Re-throw the error for non-401 errors
    throw error;
  }
};